import '@fontsource-variable/hanken-grotesk';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './ui/tokens/theme.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Provedores } from './app/provedores';
import { aplicarTema } from './lib/tema';

aplicarTema();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root ausente no index.html');

createRoot(raiz).render(
  <StrictMode>
    <Provedores />
  </StrictMode>,
);
